import { createAppSlice } from "../../utils";
import { AuthState } from "./auth.types";

const initialState = {} as AuthState;

export const authSlice = createAppSlice({
  name: "auth",
  initialState,
  reducers: (create) => ({
    setName: create.reducer<{ user: string }>((state, { payload }) => {
      Object.assign(state, { user: payload.user });
    }),
    setCredentials: create.reducer<{ token?: string } & Omit<AuthState, "token">>((state, { payload }) => {
      const { token, ...rest } = payload;

      Object.assign(state, { token, isAuthenticated: !!token, ...rest });
    }),
    logout: create.reducer((state) => {
      sessionStorage.clear();
      localStorage.clear();

      Object.assign(state, { token: null, isAuthenticated: false });
    })
  }),
  selectors: {
    session: (state) => state,
    token: (state) => state.token,
    isAuthenticated: (state) => state.isAuthenticated,
    user: (state) => state.user,
    role: (state) => state.role,
    shippingCompanyId: (state) => state.shippingCompanyId,
    id: (state) => state.id
  }
});

export const authSelectors = authSlice.selectors;
export const authSliceActions = authSlice.actions;
